/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */
import './site-3d-overview.scss';
import site3dOverviewTemplate from './site-3d-overview.tpl.html';
import { Context3D } from '../../common/silo/silo-3d-drawing' 

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.site.3dOverview', [])
    .directive('agSite3dOverview', Site3dOverview)
    .name;

/*@ngInject*/
function Site3dOverview() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            onAssetSelected: '&'
        },
        controller: Site3dOverviewController,
        controllerAs: 'vm',
        templateUrl: site3dOverviewTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function Site3dOverviewController($scope, $element, $filter, $window, attributeService, aerationService,
                              $translate, $q, $log, agTypes, types, userService, siteService, siloService, siloGroupService) {

    let vm = this;
    
    function selectAsset (assetId) {
        if (vm.onAssetSelected) {
            let item = vm.renderData.find(x => x.asset.id.id == assetId)
            if (item && item.asset) {
                vm.onAssetSelected({ asset: item.asset })
            } else {
                $log.warn('asset not selectable', item, assetId)
            }
        }
    }

    vm.assetTypes = [
        agTypes.assetType.silo, agTypes.assetType.siloGroup, 
        agTypes.assetType.weatherStation, agTypes.assetType.aeration
    ]

    vm.options = agTypes.drawing3d

    vm.agTypes = agTypes;
    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' ||
        userService.getAuthority() === 'CUSTOMER_USER';
    vm.isCustomer = userService.getAuthority() === 'CUSTOMER_USER';
    vm.loading = false;
    vm.renderData = []; // list of render data for each silo
    vm.inEditMode = false;

    vm.drawingElement = angular.element('.ag-site-3d-overview', $element);
    let sceneCanvas = angular.element('#siteSceneCanvas', $element)[0]
    
    vm.context = new Context3D(sceneCanvas, {...vm.options, ...{
        showHeadup: true,
        showGrid: false,
        showCrop: false,
        showCables: false,
        showGround: true,
        showSelection: true,
        logger: $log,
        onUserSelect: (assetId) => {
            selectAsset(assetId)
        },
    }});

    vm.toggleEditMode = function() {
        if (!vm.inEditMode) {
            // vm.context.config = {options: vm.context.options}
            vm.inEditMode = true;
            vm.context.startAdminMode((changes) => {
                vm.loading = true;
                var promises = [];
                for (var assetId in changes) {
                    var values = changes[assetId];

                    var attributes = [];
                    for (var key in values) {
                        attributes.push({key: key, value: values[key]});
                    }

                    var p = attributeService.saveEntityAttributes(
                        types.entityType.asset, assetId, types.attributesScope.server.value, attributes
                    );
                    promises.push(p);
                }
                return $q.all(promises)
                    .then((results) => {
                        vm.loading = false;
                        return results; 
                    })
                    .catch((error) => {
                        vm.loading = false;
                        $log.error('Failed to save one or more assets', error);
                        return $q.reject(error);
                    });
            }, () => {
                vm.inEditMode = false;
                loadAssets()
            })
        } else {
            //vm.context.stopEditing()
            //savePositions()          
        }
        //vm.inEditMode = !vm.inEditMode;
    }

    // function savePositions () {
    //     vm.context.listAssets().map(object => {
    //         let item = vm.renderData.find(x => x.asset.id.id == object.state.id);
    //         if (!item) {
    //             $log.warn('asset not found:', object)
    //             return
    //         }
    //         let position = object.position
    //         let asset = item.asset.data
    //
    //         if (asset.coordinate3dX != position.x || asset.coordinate3dY != position.y || asset.coordinate3dZ != position.z) {
    //             asset.coordinate3dX = position.x;
    //             asset.coordinate3dY = position.y;
    //             asset.coordinate3dZ = position.z;
    //             saveSiteAsset(asset)
    //         }
    //     })
    // }

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.ctx.widgetTitle = $translate.instant('ag.silo.silos') + '';
            vm.ctx.widgetActions = [];

            if (vm.ctx.stateController) {
                loadAssets();
                $scope.$watch(() => vm.ctx.stateController.getStateId(), (newVal, prevVal) => {
                    if (newVal) {
                        const isNewValSilo = newVal === agTypes.clientState.aeration || newVal === agTypes.clientState.weatherStation || newVal === agTypes.clientState.silo || newVal === agTypes.clientState.siloGroupSilo;
                        if (!angular.equals(newVal, prevVal) && !isNewValSilo) {
                            loadAssets();
                        }
                    } else {
                        var stateParams = vm.ctx.stateController.getStateParams();
                        stateParams.assetBrowserWidgetType = agTypes.assetBrowserWidgetType.map;
                        vm.ctx.stateController.updateState(null, stateParams, false);
                    }
                });

                $scope.$watch(() => getSelectedAssetId(), (newVal, prevVal) => {
                    if (newVal && !angular.equals(newVal, prevVal)) {
                        markAssetAsSelected(newVal.id);
                    }
                });
            }
        }
    });

    $scope.$watch('vm.renderData', () => {
        if (!vm.loading) {
            if (vm.renderData && vm.renderData.length > 0) {
                const sortedRenderData = $filter('orderBy')(vm.renderData, 'name');
                redraw(sortedRenderData);
            } else {
                clear();
            }
        }
    }, true);

    $scope.$on('siteAssetUpdated', function() {
        loadAssets();
    });

    $scope.$on("$destroy", function () {
        clear();
        vm.context.dispose();
        resetSiteAssets();
        disposeFansSubscriptions()
    });

    function clear(){
        vm.renderData = [];
        vm.context.clear();
        
    }

    function redraw(sortedRenderData) {
        if (vm.context.adminMode) {
            return
        }
        vm.context.clear()
        let selection = null
        let root = null
        $log.info('redraw', sortedRenderData, vm.options);

        for (let renderItem of sortedRenderData) {
            vm.context.addAsset({
                id: renderItem.asset.id.id,
                type: renderItem.asset.type,
                attributes: renderItem.asset.data,
                devices: [],
                systems: renderItem.systems,
                options: {
                    label: (renderItem.asset.label || renderItem.asset.name),
                    highestAlarmSeverity: renderItem.highestAlarmSeverity,
                    highestAlarmStatus: renderItem.highestAlarmStatus
                }
            });
            if (renderItem.selected) {
                selection = renderItem.asset.id.id;
            }
            if (renderItem.root && renderItem.root.id) {
                root = renderItem.root
            }
        }

        if (root && root.id) {
            vm.context.setId(root.id)
        }
        vm.context.redraw();
        
        if (selection != null) {
            vm.context.selectAsset(selection)
        }
    }
    
    function getSelectedAssetId() {
        const siloParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.clientState.silo);
        const siloGroupSiloParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.clientState.siloGroupSilo);
        if (siloParams) {
            return siloParams.entityId;
        } else if (siloGroupSiloParams) {
            return siloGroupSiloParams.entityId;
        } else {
            return null;
        }
    }

    function markAssetAsSelected(id) {
        vm.context.selectAsset(id)
    }

    $scope.$on('alarmsUpdated', function() {
        if (!vm.loading) {
            loadAssets();
        }
    });

    function resetSiteAssets() {
        vm.loading = false;
        vm.renderData = [];
        vm.siteAssetsPromise = null;
    }

    function loadAssets() {
        vm.loading = true;
        const selectedAssetId = getSelectedAssetId();
        let selectedStateId = vm.ctx.stateController.getStateId();
        let selectedEntityId = vm.ctx.stateController.getEntityId();

        if (selectedStateId.startsWith(agTypes.clientState.siloGroup)) {
            const siloGroupParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.clientState.siloGroup);
            if (siloGroupParams !== null) {
                selectedStateId = agTypes.clientState.siloGroup;
                selectedEntityId = siloGroupParams.entityId;
            }
        } else {
            const siteParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.clientState.site);
            selectedStateId = agTypes.clientState.site;
            selectedEntityId = siteParams.entityId;
        }

        
        vm.siteAssetsPromise = null;
        if (selectedStateId === agTypes.clientState.site) {
            vm.siteAssetsPromise = siteService.getSiteAssets(
                selectedEntityId,
                true,
                agTypes.assetBrowserWidgetType.dashboard,
                vm.assetTypes
            );
                    
        } else if (selectedStateId === agTypes.clientState.siloGroup) {
            vm.siteAssetsPromise = siloGroupService.getSiloGroupAssets(
                selectedEntityId,
                true,
                agTypes.assetBrowserWidgetType.dashboard ,
                vm.assetTypes
            );
        }

        if (vm.siteAssetsPromise) {
            vm.siteAssetsPromise.then(
                function success(siteAssets) {
                    vm.siteAssetsPromise = null;
                    vm.renderData = [];
                    vm.siteAssets = siteAssets;
                    const apiPromises = [];

                    for (let assetIndex in siteAssets) {
                        const asset = siteAssets[assetIndex];
                        
                        let apiRef = null
                        if (asset.type === agTypes.assetType.silo) {
                            apiRef = siloService.getSilo;
                        } else if (asset.type === agTypes.assetType.aeration) {
                            apiRef = aerationService.getAeration;
                        } else {
                            apiRef = siloGroupService.getSiloGroup;
                        }
                        
                        apiPromises.push(apiRef(asset.id).then(response => {
                            asset.data = response;
                            return asset
                        }));
                    }

                    initFansSubscriptions();
                    $q.all(apiPromises).then(function(assets){
                        vm.renderData = [];
                        let connectedSystems = {};
                        let renderData = assets.map(asset => {
                            let renderData = {
                                root: selectedEntityId,
                                name: (asset.label || asset.name),
                                asset: asset,
                                highestAlarmSeverity: asset.highestAlarmSeverity,
                                highestAlarmStatus: asset.highestAlarmStatus,
                                selected: selectedAssetId && selectedAssetId.id === asset.id.id
                            }
                            if (asset.connectedSystems) {
                                renderData.systems = asset.connectedSystems.map(sys => {
                                    return {id: sys.id.id}
                                });
                                asset.connectedSystems?.map(system => {
                                    connectedSystems[system.id.id] = system;                                    
                                });
                            }
                            return renderData
                        });
                        renderData.map(data => {
                            let system = connectedSystems[data.asset.id.id];
                            if (angular.isDefined(system)) {
                                data.highestAlarmSeverity = system.highestAlarmSeverity;
                                data.highestAlarmStatus = system.highestAlarmStatus;
                            }
                        });
                        vm.renderData = renderData
                        vm.loading = false;
                    });
                },
                function fail() {
                    resetSiteAssets()
                }
            )
        } else {
            resetSiteAssets();
        }
    }

    vm.siteAssets = []
    vm.latestValuesSubscription = null
    vm.latestFanValuesSubscriptionOptions = {
        callbacks: {
          onDataUpdated: onFansUpdated,
          onDataUpdateError: onDataUpdateError,
          dataLoading: function() {}
        },
        useDashboardTimewindow: false
    };
    function onFansUpdated(subscription, apply) {
        subscription.data.map(item => {
            if (item.dataKey.name == 'state' && item.data.length > 0) {
                let value = item.data[0][1];
                let assetId = item.datasource.entityId;
                vm.context.updateAerationState(assetId, value);
            }
        })
        if (apply) {
          $scope.$digest();
        }
    }
    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }
    function disposeFansSubscriptions () {
        if (vm.latestValuesSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.latestValuesSubscription.id);
        }
    }
    function initFansSubscriptions () {
        disposeFansSubscriptions()
        const latestValuesSubscriptionsInfo = [];
        for (let asset of vm.siteAssets) {
            if (asset.type !== agTypes.assetType.aeration) {
                continue
            }
            
            latestValuesSubscriptionsInfo.push({
                type: types.datasourceType.entity,
                entityType: types.entityType.asset,
                entityId: asset.id.id,
                entityName: asset.name,
                timeseries: [
                    {name: vm.agTypes.telemetry.aeration.state}
                ]
            });
        }

        vm.ctx.subscriptionApi.createSubscriptionFromInfo(
            types.widgetType.latest.value, latestValuesSubscriptionsInfo, vm.latestFanValuesSubscriptionOptions, false, true).then(
            function(subscription) {
                vm.latestValuesSubscription = subscription;
            }
        );
    }

    // function saveSiteAsset(siteAsset) {
    //     vm.loading = true;
    //     var deferred = $q.defer();
    //     const attributeKeys = [agTypes.attributes.baseAsset.coordinate3dX, agTypes.attributes.baseAsset.coordinate3dY, agTypes.attributes.baseAsset.coordinate3dZ];
    //     var saveSiteAssetPromise = siteService.saveAssetPosition(siteAsset, attributeKeys);
    //     if (saveSiteAssetPromise) {
    //         saveSiteAssetPromise.then(
    //             function success() { },
    //             function fail() { deferred.reject();
    //             }
    //         ).finally(() => vm.loading = false)
    //     } else {
    //         deferred.reject();
    //     }
    //     return deferred.promise;
    // }
}
